import { render, staticRenderFns } from "./CreateCampaignSourceReview.vue?vue&type=template&id=01bf64ee&scoped=true"
import script from "./CreateCampaignSourceReview.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSourceReview.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignSourceReview.vue?vue&type=style&index=0&id=01bf64ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bf64ee",
  null
  
)

export default component.exports